export enum EvolutionIndicatorEnum {
  up = 'up',
  down = 'down',
  equal = 'equal',
}
